import './BoardDefsEditor.scss'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Divider from '@material-ui/core/Divider'
import { MenuItem } from '@material-ui/core'
import Typography from '@material-ui/core/Typography'
import Paper from '@material-ui/core/Paper'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import LoadBoardDefsModal from './LoadBoardDefsModal'
import BoardDefJsonViewer from './BoardDefJsonViewer'
import SwimlanesEditor from './SwimlanesEditor'
import BoardInfoDialog from './BoardInfoDialog'
import { List, ListItem, ListItemSecondaryAction, ListItemText } from '@material-ui/core'
import MoreVertMenu from '../../MoreVertMenu'

/**
 * BoardDefsEditor
 */
export class BoardDefsEditor extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      boardInfoOpen: false,
      loadJsonModalOpen: false,
      jsonViewOpen: false,
      viewInfoDef: null,
      boardListMenuOpen: false
    }
  }

  UNSAFE_componentWillMount() {
    if (!this.props.isLoaded) {
      this.props.loadEditorData()
    }
  }

  setCurrentBoardName = value => {
    const board = { ...this.props.currentBoard, name: value}
    this.props.setCurrentBoard(board)
  }

  setCurrentBoardById(id) {
    const selectedBoard = { ...this.props.boardDefs[id] }
    this.props.setCurrentBoard(selectedBoard)
  }

  updateLane = (laneId, newLane) => {
    const lanes = this.props.currentBoard.swimlanes || []

    const newLanes = newLane === null
      ? lanes.filter(l => l.id !== laneId)
      : lanes.map(l => l.id === laneId ? newLane : l)
    this.updateLanes(newLanes)
  }

  updateLanes = newLanes => {
    const board = { ...this.props.currentBoard, swimlanes: newLanes }
    this.props.setCurrentBoard(board)
  }

  addLane = () => {
    const maxId = this.props.currentBoard.swimlanes
      .reduce((id, lane) => Math.max(lane.id, id), 0)
    const nextId = `${maxId + 1}`
    const swimlanes = [...this.props.currentBoard.swimlanes, {
      id: nextId,
      name: `Lane ${nextId}`,
      mapping: {
        startPercent: 0,
        endPercent: 100,
        onHold: false,
        setPercentCompleteTo: 1
      }
    }]

    const board = { ...this.props.currentBoard, swimlanes}
    this.props.setCurrentBoard(board)
  }

  addBoardDef = () => {
    const maxId = this.props.boardDefsList.reduce((maxId, def) => Math.max(parseInt(def.id, 10), maxId), 1)
    const nextId = `${maxId + 100}`
    const newBoardDef = {
      id: nextId,
      name: `Custom Board #${this.props.boardDefsList.length}`,
      swimlanes: []
    }
    const newDefs = { ...this.props.boardDefs, [newBoardDef.id]: newBoardDef }

    this.props.updateBoardDefs(newDefs)
    this.props.setCurrentBoard(newBoardDef)
  }

  saveCurrentBoard = () => {
    const ensureOnHoldPercentages = lane => {
      if (lane.mapping.onHold) {
        lane.mapping.startPercent = 0
        lane.mapping.endPercent = 100
        delete lane.mapping.setPercentCompleteTo
      }

      return lane
    }

    const swimlanes = this.props.currentBoard.swimlanes.map(ensureOnHoldPercentages)
    const currentBoard = {
      ...this.props.currentBoard,
      swimlanes
    }
    const newDefs = {
      ...this.props.boardDefs,
      [this.props.currentBoard.id]: currentBoard
    }

    this.props.updateBoardDefs(newDefs)
    this.props.setCurrentBoard(null)
  }

  cancelCurrentBoardEdits() {
    this.props.setCurrentBoard(null)
  }

  deleteBoard(id) {
    let newDefs = { ...this.props.boardDefs }
    delete newDefs[id]

    this.props.updateBoardDefs(newDefs)

    if (this.props.currentBoard && this.props.currentBoard.id === id) {
      this.props.setCurrentBoard(null)
    }
  }

  render() {
    const currentBoardId = this.props.currentBoard ? this.props.currentBoard.id : ''

    const cleanSwimlaneData = lane => {
      if ((typeof lane.id) !== 'string') {
        lane.id = `${lane.id}`
      }
      if ((typeof lane.mapping.startPercent) === 'string') {
        lane.mapping.startPercent = parseInt(lane.mapping.startPercent, 10)
      }
      if ((typeof lane.mapping.endPercent) === 'string') {
        lane.mapping.endPercent = parseInt(lane.mapping.endPercent, 10)
      }
      if ((typeof lane.mapping.setPercentCompleteTo) === 'string') {
        lane.mapping.setPercentCompleteTo = parseInt(lane.mapping.setPercentCompleteTo, 10)
      }
      return lane
    }

    const cleanBoardData = board => {
      if ((typeof board.id) !== 'string') {
        board.id = `${board.id}`
      }
      board.swimlanes = board.swimlanes.map(cleanSwimlaneData)
      return board
    }

    const onDataLoad = data => {
      const defs = data.map(b => cleanBoardData(b))
      this.props.loadDefsList(defs)
      this.setState({loadJsonModalOpen: false})
    }
    const onDataLoadCancel = () => this.setState({loadJsonModalOpen: false})
    const promptForDataLoad = () => this.setState({loadJsonModalOpen: true})

    const closeJsonViewer = () => this.setState({jsonViewOpen: false})
    const showJsonViewer= () => this.setState({jsonViewOpen: true})
    const showInfo = def => this.setState({viewInfoDef: def, boardInfoOpen: true})
    const hideInfo = () => this.setState({viewInfoDef: null, boardInfoOpen: false})

    return this.props.isLoaded && (
      <div className='board-editor-container'>
        <Paper className='editor--board-list'>
          {this.props.boardDefs && (
            <List dense value={currentBoardId} onChange={(event, boardId) => this.setCurrentBoardById(boardId)} >
              <MoreVertMenu id='board-list-menu' className='editor--board-list--menu'>
                <MenuItem onClick={this.addBoardDef}>Add New Board</MenuItem>
                <Divider />
                <MenuItem onClick={showJsonViewer}>View JSON</MenuItem>
                <MenuItem onClick={promptForDataLoad}>Load From JSON</MenuItem>
              </MoreVertMenu>
              <Typography style={{ padding: '12px' }} type='subheading'>Available Boards</Typography>
              <BoardInfoDialog open={this.state.boardInfoOpen} boardDef={this.state.viewInfoDef} closeAction={hideInfo} />
              <BoardDefJsonViewer open={this.state.jsonViewOpen} boardDefs={this.props.boardDefsList} closeAction={closeJsonViewer} />
              <LoadBoardDefsModal open={this.state.loadJsonModalOpen} loadAction={onDataLoad} cancelAction={onDataLoadCancel}/>

              {this.props.boardDefsList.map((def) => (
                <ListItem key={def.id} button>
                  <ListItemText
                    onClick={() => this.setCurrentBoardById(def.id)}
                    primary={def.name}
                    secondary={def.swimlanes.map(sl => (
                      <span key={sl.id} className='board-selector-option-lane'>{sl.name}</span>
                    ))} />
                  <ListItemSecondaryAction>
                    <MoreVertMenu id={def.name}>
                      <MenuItem onClick={() => showInfo(def)}>Show Info</MenuItem>
                      <Divider />
                      <MenuItem onClick={() => this.deleteBoard(def.id)}>Delete</MenuItem>
                    </MoreVertMenu>
                  </ListItemSecondaryAction>
                </ListItem>
              ))}
            </List>
          )}
        </Paper>

        {!!currentBoardId && (
          <div className='editor--board-details-table'>
            <TextField
              onChange={event => this.setCurrentBoardName(event.target.value)}
              value={this.props.currentBoard.name}
              label='Board Name'
              fullWidth />
            <SwimlanesEditor swimlanes={this.props.currentBoard.swimlanes} addLane={this.addLane} onChange={swimlanes => this.updateLanes(swimlanes)} />
            <div className='editor--board-details-actions'>
              <Button color='primary' onClick={() => this.saveCurrentBoard()}>Save</Button>
              <Button color='primary' onClick={() => this.props.setCurrentBoard(null)}>Cancel</Button>
            </div>
          </div>
        )}
      </div>
    )
  }
}

BoardDefsEditor.propTypes = {
  boardDefs: PropTypes.object,
  currentBoard: PropTypes.object
}

export default BoardDefsEditor



// WEBPACK FOOTER //
// ./src/routes/BoardDefsEditor/components/BoardDefsEditor.js